import { render, staticRenderFns } from "./CreateDepartment.vue?vue&type=template&id=21b44b98&"
import script from "./CreateDepartment.vue?vue&type=script&lang=js&"
export * from "./CreateDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports